interface PreviewTitleProps {
  title: string;
  subtitle: string;
}

export const PreviewTitle = ({ title, subtitle }: PreviewTitleProps) => (
  <div>
    <div className="text-light text-sm">{subtitle}</div>
    <div className="text-default text-lg font-medium">{title}</div>
  </div>
);
